<template>
  <div>
    <b-card>
      <div slot="header">
        <i class='fa fa-align-justify'></i><strong class='header-spacing'>Additional Info</strong>
      </div>
      <div v-if="bookingReason && bookingReason.reason">
        <p class="mb-1"><strong>Reason for booking:</strong> {{bookingReason.reason}}</p>
        <p class="mb-1" v-if="bookingReason.condition"><strong>Condition:</strong> {{bookingReason.condition}}</p>
        <p v-if="bookingReason.extraDetails"><strong>Details:</strong> {{bookingReason.extraDetails}}</p>
      </div>
      <p v-if="order.workflow && order.workflow.PRESENTING_COMPLAINT">{{order.workflow.PRESENTING_COMPLAINT}}</p>
      <p v-if="(!order.workflow || !order.workflow.PRESENTING_COMPLAINT) && !(bookingReason && bookingReason.reason)">Not provided.</p>
    </b-card>
  </div>
</template>

<script>
  export default {
    name: "additional-order-info",
    props: ['order'],
    data() {
      return {
        bookingReason: null
      }
    },
    watch: {
      'order.id': {
        immediate: true,
        handler(orderId) {
          this.bookingReason = null;
          if (!orderId) return;
          this.$orderService.getBookingReason(orderId)
            .then(reason => { this.bookingReason = reason; })
            .catch(() => { this.bookingReason = null; });
        }
      }
    }
  }
</script>
